import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';
import { TableSettingsService } from '../../services/table-settings.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-table-settings',
  imports: [ButtonModule, TooltipModule, TranslocoPipe, PopoverModule],
  templateUrl: './table-settings.component.html',
})
export class TableSettingsComponent {
  packLimitationService = inject(PackLimitationsService);
  tableSettingService = inject(TableSettingsService);
}
